import { render, staticRenderFns } from "./SeatingSelectionInfo.vue?vue&type=template&id=2da59f6e&"
import script from "./SeatingSelectionInfo.vue?vue&type=script&lang=js&"
export * from "./SeatingSelectionInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports